import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { IToolkitDialogExtension, ToolkitDialogOptions } from './interface';
import i18n from '@i18next/i18n';

export async function showToolkitDialog(options: ToolkitDialogOptions) {
    const extension = await ArkLoader.extensionService.getExtension<IToolkitDialogExtension>(componentConfig.name);
    extension.show(options);
}

export function showImagesJoint(aidConfig: Pick<ToolkitDialogOptions, 'aidPosition' | 'fromPage' | 'contentAidOptions'>) {
    const mergeImagesDialogOptions = {
        title: i18n.t('图片拼接'),
        toolId: 'image_stitching',
        toolPath: 'https://docs.qq.com/open/toolkit/pic-joint.html',
        aidPosition: aidConfig.aidPosition,
        fromPage: aidConfig.fromPage,
        contentAidOptions: aidConfig.contentAidOptions,
    };
    showToolkitDialog(mergeImagesDialogOptions);
}
